module.exports = __webpack_public_path__ + "static/2-bd83fbf059c96d85cac043bdcab45431.png";